import { Link } from "react-router-dom";
import { Mail, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { FOOTER } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer data-testid={FOOTER.container} className="relative bg-[#0A2540] text-slate-300 overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-[0.06]" />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 h-64 w-[800px] bg-emerald-500/10 blur-3xl rounded-full" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center mb-6">
              <img
                src="/assets/cascade-headerlogo.png"
                alt="Cascade Plus"
                className="h-24 w-auto max-w-[260px] object-contain"
              />
            </div>
            <p className="text-slate-400 max-w-md leading-relaxed mb-8">
              The UK's only independent purchasing support service helping community pharmacies save on pharmaceutical procurement. Be independent, but don't be alone.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-emerald-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-emerald-600 transition-all hover:gap-3"
            >
              Start saving today
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Product</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/services" className="hover:text-emerald-400 transition-colors">How it Works</Link></li>
              <li><Link to="/benefits" className="hover:text-emerald-400 transition-colors">Benefits</Link></li>
              <li><Link to="https://orderpad.cascadeplus.co.uk/" className="hover:text-emerald-400 transition-colors">Order platform</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Company</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="hover:text-emerald-400 transition-colors">About</Link></li>
              <li><Link to="/contact" className="hover:text-emerald-400 transition-colors">Contact</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-emerald-400 transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Get in touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 mt-0.5 text-emerald-400 shrink-0" />
                <a
                  data-testid={FOOTER.emailLink}
                  href="mailto:info@cascadeplus.co.uk"
                  className="hover:text-emerald-400 transition-colors break-all"
                >
                  info@cascadeplus.co.uk
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="h-4 w-4 mt-0.5 text-emerald-400 shrink-0" />
                <span>Live assistance 9:00 - 18:00</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-emerald-400 shrink-0" />
                <span>United Kingdom</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 items-center justify-between text-sm text-slate-500">
          <p>
            Copyrights &copy; 2026 All Rights Reserved by{" "}
            <a
              href="https://www.luxshtech.com/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-emerald-400 transition-colors"
            >
              Luxsh Technologies
            </a>
            .
          </p>
          <p>Independent. Unbiased. For pharmacists, by pharma veterans.</p>
        </div>
      </div>
    </footer>
  );
}
